const remove_persistence = {
  6: (state) => {
    return {}
  },
}

export default remove_persistence
